export default __webpack_public_path__ + "static/media/noImage.9fe89123.jpg";